// ===== Packages =====

import React                                    from 'react';
import styled                                   from 'styled-components';
import { v4 as uuidv4 }                         from 'uuid';

// ===== Services =====

import {
    setColorLightness,
}                                               from '../../../services';

// ===== Constants =====

import {
    BODY_FONT_SIZE,
    SUCCESS_BACKGROUND_LIGHTNESS_VALUE,
    ERROR_BACKGROUND_LIGHTNESS_VALUE,
    SLATE_PARAGRAPH_CLASSNAME,
}                                               from '../../../constants/generalConstants';
import FONT_TYPE                                from '../../../constants/fontType';

// ===== Styles =====

import { basicEditorFontStyles }                from '../../../styles';

Paragraph.defaultProps = {
    fontFamily: null,
    hasSuccess: false,
    hasError: false,
    paragraphId: undefined,
    plainText: undefined,
};
interface Props {
    hasSuccess?: boolean,
    hasError?: boolean,
    fontFamily?: string,
    paragraphId?: string,
    plainText?: string,
    children: React.ReactElement,
    attributes: any,
}
function Paragraph({
    fontFamily,
    hasSuccess,
    hasError,
    paragraphId,
    plainText,
    children,
    attributes,
}: Props): JSX.Element {
    // Fall back to runtime id for legacy nodes that haven't been normalized with paragraphId yet.
    const resolvedParagraphId = paragraphId || uuidv4();
    const normalizedTargetLabel = `${plainText || ''}`.replace(/\s+/g, ' ').trim();
    return (
        <Container
            {...attributes}
            data-paragraph-id={resolvedParagraphId}
            data-post-link-target-id={resolvedParagraphId}
            {...(normalizedTargetLabel
                ? {
                    'data-post-link-target-label': normalizedTargetLabel,
                }
                : {}
            )}
            className={SLATE_PARAGRAPH_CLASSNAME}
            hasSuccess={hasSuccess}
            hasError={hasError}
            fontFamily={fontFamily}
        >
            {children}
        </Container>
    );
}

// ===== Styled Components =====

interface ParagraphProps {
    hasSuccess: boolean,
    hasError: boolean,
    fontFamily?: string,
}
const Container = styled.div<ParagraphProps>`
    ${basicEditorFontStyles}
    font-family: ${({ fontFamily }) => fontFamily || FONT_TYPE.SPECTRAL};
    margin: 0;
    margin-bottom: ${`${0.3125 * BODY_FONT_SIZE}px`};
    scroll-margin-top: ${`${3.5 * BODY_FONT_SIZE}px`};
    background: ${({
        hasSuccess,
        hasError,
        theme,
    }) => {
        if (hasError) {
            return setColorLightness(
                theme.color.error,
                ERROR_BACKGROUND_LIGHTNESS_VALUE,
            );
        }

        if (hasSuccess) {
            return setColorLightness(
                theme.verascopeColor.blue200,
                SUCCESS_BACKGROUND_LIGHTNESS_VALUE,
            );
        }

        // Rather than be none, we want a transparent the background color
        // so that the background transitions in response to hover events
        return 'transparent';
    }};
`;

export default Paragraph;
